/**
 * B2B Collection – View Toggle (List / Grid)
 * Speichert die Präferenz im localStorage.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'b2b_collection_view';
  const DEFAULT_VIEW = 'list'; // Liste ist Default für B2B

  function getView() {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_VIEW;
    } catch (_) {
      return DEFAULT_VIEW;
    }
  }

  function setView(view) {
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch (_) {}
  }

  function applyView(wrapper, view) {
    if (!wrapper) return;
    wrapper.setAttribute('data-collection-view', view);

    // Toggle-Buttons aktualisieren
    wrapper.querySelectorAll('.b2b-view-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.view === view);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.getElementById('ProductGridContainer');
    if (!wrapper) return;

    // Initiale Ansicht setzen
    applyView(wrapper, getView());

    // Klick-Handler für Toggle-Buttons
    wrapper.querySelectorAll('.b2b-view-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        const view = btn.dataset.view;
        applyView(wrapper, view);
        setView(view);
      });
    });
  });
})();
